import classNames from "classnames";
import React, { useCallback, useState } from "react";
import { useDropzone } from "react-dropzone";
import EditUploadedAvatarModal from "./EditUploadedAvatarModal";
import { PhosphorCamera } from "components/Atoms/PhosphorIcon";

interface Props {
  avatarUrl?: string
  size?: "small" | "large"
  onSave: (file: File) => void
}

const UploadAvatar = (props: Props) => {
  const { avatarUrl, size = "large" } = props;
  const [isInEditMode, setIsInEditMode] = useState(false);
  const [file, setFile] = useState<File | null>(null);

  const onDrop = useCallback((acceptedFiles: File[]) => {
    // This should never happen, as we limit files to one
    if (acceptedFiles.length !== 1) {
      return;
    }

    setFile(acceptedFiles[0]);
    setIsInEditMode(true);
  }, []);

  const onSave = (file: File) => {
    setIsInEditMode(false);
    props.onSave(file);
  };

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: { "image/*": [".png", ".jpg", ".jpeg", ".pjpeg"] },
    maxFiles: 1,
    noDrag: true,
    multiple: false
  });

  return <>
    <div className={classNames("upload-avatar-wrapper", size)} {...getRootProps()}>
      <input {...getInputProps()} />
      {avatarUrl
        ? <div className="upload-avatar-image-wrapper">
          <img className="upload-avatar-image" src={avatarUrl} alt="avatar" />
          <div className={classNames("upload-avatar-icon", size)}>
            <PhosphorCamera iconSize={props.size === "small" ? "regular" : "large"} />
          </div>
        </div>
        : <a
          className="upload-avatar-placeholder"
        >{size !== "small" ? RESX.Buttons.UploadPhoto : RESX.Buttons.Upload}</a>
      }
    </div>
    {isInEditMode && <EditUploadedAvatarModal
      file={file}
      onClose={() => { setIsInEditMode(false); }}
      onSave={onSave}
    />}
  </>;
};

export default UploadAvatar;